import {
  ICtaBannerItem,
  ICtaBanners,
  ICtaBannersFields,
  IGradientColorFields,
} from '__generated__/contentful'

import { CONTENT_TYPES, contentfulClient } from 'utils/sdks/contentful'

import { ERROR_MESSAGES } from '../constants'

type FilterFields = Partial<Omit<ICtaBannersFields, 'ctaBannerItems'>>

/**
 * Fetches a CTA Banner by the given fields.
 * The fields allowed are: visibleInPage and name.
 * @param fields
 */
export const getCTABannerByFields = async (fields: FilterFields) => {
  const query = Object.entries(fields).reduce(
    (acc, [key, value]) => {
      return {
        ...acc,
        [`fields.${key}`]: value,
      }
    },
    {} as Record<string, unknown>,
  )

  try {
    return await contentfulClient.getEntries<ICtaBanners>({
      ...query,
      content_type: CONTENT_TYPES.CTA_BANNERS,
    })
  } catch (err) {
    console.error(ERROR_MESSAGES.ERROR_FETCHING_BANNERS, err)
  }
}

/**
 * Fetches the CTA Banner Items from a CTA Banner by the given fields.
 * The fields allowed are: visibleInPage and name.
 * @param fields
 */
export const getCTABannerItems = async (
  fields: FilterFields,
): Promise<ICtaBannerItem[]> => {
  let items: ICtaBannerItem[] = []
  try {
    const banner = await getCTABannerByFields(fields)
    items = banner?.includes?.Entry ?? []
  } catch (err) {
    console.error(ERROR_MESSAGES.ERROR_FETCHING_BANNER_ITEMS, err)
  }
  return items
}

/**
 * Fetches a Gradient Color by its sys id.
 * @param id
 */
export const getGradientColorById = async (id: string) => {
  try {
    return await contentfulClient.getEntry<IGradientColorFields>(id)
  } catch (err) {
    console.error(ERROR_MESSAGES.ERROR_FETCHING_GRADIENT_COLOR, err)
  }
}
